<template>
  <div class="card shadow-sm" :class="shrinkProp ? 'col-6' : 'col-12'">
    <div class="card-header d-flex flex-row justify-content-around">
      <p class="category ml-0 mr-2 my-auto">VISUALIZADOR DE TURNOS</p>
      <button
        @click="goToCreator()"
        class="btn btn-success ml-1 p-0 round-button rounded-circle mt-0 my-auto"
        style="height: 35px; width: 35px"
      >
        <i role="button" class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </button>
      <span class="ml-auto mr-0 my-auto"
        >Total:
        <badge class="" slot="title-label" type="success">{{
          paginationProp.total
        }}</badge></span
      >
    </div>
    <div class="card-body" style="overflow-x: auto;">
      <table class="table table-sm mx-auto table-hover shadow-sm rounded" style="min-width: 900px;">
        <thead class="bg-warning">
          <tr class="">
            <th class="text-center" style="width: 50px;">id</th>
            <th class="">Nombre</th>
            <th class="text-center" style="width: 90px;">Estado</th>
            <th class="text-center" style="width: 40px;">lu</th>
            <th class="text-center" style="width: 40px;">ma</th>
            <th class="text-center" style="width: 40px;">mi</th>
            <th class="text-center" style="width: 40px;">ju</th>
            <th class="text-center" style="width: 40px;">vi</th>
            <th class="text-center" style="width: 40px;">sa</th>
            <th class="text-center" style="width: 40px;">do</th>
          </tr>
        </thead>
        <tbody class="">
          <tr
            v-for="(shift, index) in tableData"
            :key="shift._id ? shift._id : index"
            @click="shiftClicked(shift.id)"
          >
            <td class="cursor-pointer text-center">{{ shift.id }}</td>
            <td class="cursor-pointer">
              {{ shift.descripcionTurno }}
            </td>
            <td class="cursor-pointer text-center">
              <span 
                class="badge" 
                :class="shift.activo ? 'badge-success' : 'badge-danger'"
              >
                {{ shift.activo ? 'Activo' : 'Inactivo' }}
              </span>
            </td>
            <td class="cursor-pointer text-center">
              <i
                :class="
                  shift.lunesAutorizado
                    ? 'fa fa-check text-success fa-lg'
                    : 'fa fa-ban text-danger fa-lg'
                "
                aria-hidden="true"
              ></i>
            </td>
            <td class="cursor-pointer text-center">
              <i
                :class="
                  shift.martesAutorizado
                    ? 'fa fa-check text-success fa-lg'
                    : 'fa fa-ban text-danger fa-lg'
                "
                aria-hidden="true"
              ></i>
            </td>
            <td class="cursor-pointer text-center">
              <i
                :class="
                  shift.miercolesAutorizado
                    ? 'fa fa-check text-success fa-lg'
                    : 'fa fa-ban text-danger fa-lg'
                "
                aria-hidden="true"
              ></i>
            </td>
            <td class="cursor-pointer text-center">
              <i
                :class="
                  shift.juevesAutorizado
                    ? 'fa fa-check text-success fa-lg'
                    : 'fa fa-ban text-danger fa-lg'
                "
                aria-hidden="true"
              ></i>
            </td>
            <td class="cursor-pointer text-center">
              <i
                :class="
                  shift.viernesAutorizado
                    ? 'fa fa-check text-success fa-lg'
                    : 'fa fa-ban text-danger fa-lg'
                "
                aria-hidden="true"
              ></i>
            </td>
            <td class="cursor-pointer text-center">
              <i
                :class="
                  shift.sabadoAutorizado
                    ? 'fa fa-check text-success fa-lg'
                    : 'fa fa-ban text-danger fa-lg'
                "
                aria-hidden="true"
              ></i>
            </td>
            <td class="cursor-pointer text-center">
              <i
                :class="
                  shift.domingoAutorizado
                    ? 'fa fa-check text-success fa-lg'
                    : 'fa fa-ban text-danger fa-lg'
                "
                aria-hidden="true"
              ></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-sm-6 container-fluid d-flex mt-4">
      <p-pagination
        class="pull-right mx-auto"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="paginationProp.total"
      >
      </p-pagination>
    </div>
  </div>
</template>

<script>
import PPagination from "src/components/UIComponents/Pagination.vue";
import { Badge } from "src/components/UIComponents";
export default {
  name: "shiftsTable",
  components: {
    PPagination,
    Badge,
  },
  watch: {
    "pagination.currentPage": function (newValue) {
      this.$emit("pageChage", newValue);
    },
    shrinkProp: function (newValue) {
      if (newValue != this.shrink) {
        this.shrink = newValue;
      }
    },
    tableData: {
      immediate: true,
      handler(newVal) {
        // Debug para verificar que los datos tienen el campo activo
        if (newVal && newVal.length > 0) {
          console.log('Datos de turnos recibidos:', newVal[0]);
        }
      }
    }
  },
  props: {
    paginationProp: {
      type: Object,
      default: { total: 10 },
    },
    shrinkProp: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Array,
      default: [
        {
          _id: "mockId",
          id: 0,
          descripcionTurno: "Nombre Turno",
          lunesAutorizado: false,
          martesAutorizado: false,
          miercolesAutorizado: false,
          juevesAutorizado: false,
          viernesAutorizado: false,
          sabadoAutorizado: false,
          domingoAutorizado: false,
          activo: true,
        },
        {
          _id: "mockId2",
          id: 0,
          descripcionTurno: "Nombre Turno",
          lunesAutorizado: false,
          martesAutorizado: false,
          miercolesAutorizado: false,
          juevesAutorizado: false,
          viernesAutorizado: false,
          sabadoAutorizado: false,
          domingoAutorizado: false,
          activo: false,
        },
      ],
    },
    documentsTotal: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      pagination: {
        currentPage: 1,
        perPage: 10,
      },
      shrink: false,
    };
  },
  methods: {
    getCurrentPage() {
      return this.pagination.currentPage;
    },
    shiftClicked(id) {
      this.$emit("shiftClicked", id);
    },
    goToCreator() {
      this.$swal.fire({
        title: 'Cargando',
        text: "Un momento por favor...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.$router.push({
        name: "Create",
        query: { run: "WHbUjdv3TG" },//WHbUjdv3TG = "shift"
      });
    },
  },
};
</script>

<style>
.cursor-pointer:hover {
  cursor: pointer;
}

/* Asegurar que los badges tengan el tamaño correcto */
.badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

/* Forzar que la tabla use todo el ancho disponible */
.table {
  width: 100%;
}
</style>
